import { useEffect, useState } from "react";
import { db } from "../firebase";
import { ToastContainer, toast } from "react-toastify";
import axios from 'axios';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { auth } from "../firebase";
import { arrayUnion, doc, updateDoc, getDoc } from "firebase/firestore"; // Importuj odpowiednie metody z Firebase
import moment from "moment";
import {
  updatePreAlert,
  updateTitle,
  updatePreAlerts,
  updatePreAlertID,
} from "../features/counter/counterSlice"; // material-tailwind components
import { List, ListItem, Card, input } from "@material-tailwind/react";
import {
  Button,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
} from "reactstrap";
import { Dialog, DialogBody } from "@material-tailwind/react";
import { FaPlus } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

function PreAlertManagment() {
  const [filteredPreAlerts, setFilteredPreAlerts] = useState();
  const preAlert = useSelector((state) => state.store.preAlert);
  const preAlerts = useSelector((state) => state.store.preAlerts);
  const title = useSelector((state) => state.store.title);
  const [unitsTotal, setUnitsTotal] = useState(0);
  const [palletsTotal, setPalletsTotal] = useState(0);
  const [preAlertHeight, setPreAlertHeight] = useState(0);
  const dispatch = useDispatch();
  const [fields, setFields] = useState(0);
  const [isCanceled, setIsCanceled] = useState(false);
  const navigate = useNavigate();

  const [objectValue, setObjectValue] = useState({
    cars: [
      { receiving: "", id: 1, quantity: 0, palletsNumber: 0, numberFBA: "" },
      { receiving: "", id: 2, quantity: 0, palletsNumber: 0, numberFBA: "" },
    ],
  });

  const alertID = async () => {
    try {
      const docRef = doc(db, "pre-alerts", "euoso0pRR5PZw2wBnjOW"); // odwołanie do dokumentu
      const docSnap = await getDoc(docRef); // pobieramy dokument

      if (docSnap.exists()) {
        const alerts = docSnap.data().alerts.sort((a, b) => a.id - b.id);
        const id = alerts[alerts.length-1].id + 1;
        return id;
      }
    } catch (error) {
      console.error("Błąd podczas pobierania dokumentu:", error);
      return null; // w przypadku błędu zwracamy null lub inną odpowiednią wartość
    }
  };

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user.displayName === "porter") {
        navigate("/super-admin/parking-map");
      }
    });
  }, []);

  useEffect(() => {
    if (Object.keys(preAlert).length > 0) {
      // Tworzymy nowy stan na podstawie nowej długości tablicy samochodów w preAlert
      const initialCars = [];

      // Dodajemy nowe samochody na podstawie nowej długości tablicy samochodów w preAlert
      const additionalCarsCount = preAlert.cars.length;
      for (let i = 0; i < additionalCarsCount; i++) {
        initialCars.push({
          receiving: preAlert.cars[i].receiving,
          id: initialCars.length + 1, // Nowy numer ID
          quantity: preAlert.cars[i].quantity,
          palletsNumber: preAlert.cars[i].palletsNumber,
          numberFBA: preAlert.cars[i].numberFBA,
        });
      }

      // Aktualizujemy stan objectValue na podstawie nowej tablicy samochodów
      setObjectValue({ cars: initialCars });
    }
  }, [preAlert]);

  const [wantedAlert, setWantedAlert] = useState("");
  const [emailValidate, setEmailValidate] = useState(true);

  const filteredAlerts = () => {
    if (preAlerts) {
      const found = preAlerts.filter((alert) => {
        const preAlertId = `Pre-Alert no #${alert.id}`.toLowerCase();
        const from = alert.from.toLowerCase();
        const numberFBA1 = alert.cars[0].numberFBA;
        const numberFBA2 = alert.cars[1].numberFBA;

        return (
          preAlertId.includes(wantedAlert.toLowerCase()) ||
          from.includes(wantedAlert.toLowerCase()) ||
          numberFBA1.includes(wantedAlert) ||
          numberFBA2.includes(wantedAlert)
        );
      });
      setFilteredPreAlerts(found);
    }
  };

  const getAlerts = async () => {
    try {
      // Użyj funkcji doc do uzyskania referencji do dokumentu
      const docRef = doc(db, "pre-alerts", "euoso0pRR5PZw2wBnjOW");
      const response = await getDoc(docRef); // Użyj getDoc do pobrania dokumentu

      if (response.exists()) {
        const { alerts = [] } = response.data(); // Destrukturyzacja z domyślną wartością jako pustą tablicą

        // Aktualizacja ID i sortowanie alertów
        dispatch(updatePreAlertID(alerts.length + 1));
        dispatch(updatePreAlerts(alerts.sort((a, b) => b.id - a.id)));
      } else {
        console.log("Document not found");
        dispatch(updatePreAlerts([])); // W przypadku braku dokumentu, wyczyść alerty
      }
    } catch (error) {
      console.error("Error fetching alerts: ", error);
    }
  };

  useEffect(() => {
    getAlerts();
  }, []);

  useEffect(() => {
    if(objectValue.type !== 'loose'){
      setObjectValue((prevState) => ({
        ...prevState,
        trailerType: '',
      }));
    }
  }, [objectValue])

  const checkTable = () => {
    const inputs = document.querySelectorAll("#amazon-table input");
    const inputsArray = Array.from(inputs);
    const chunks = [];
    const chunkSize = 4;

    for (let i = 0; i < inputsArray.length; i += chunkSize) {
      const chunk = inputsArray.slice(i, i + chunkSize);
      chunks.push(chunk);
    }

    chunks.forEach((chunk, index) => {
      if (index !== 0) {
        const allEmpty = chunk.every((field) => field.value === ""); // Sprawdzamy, czy wszystkie elementy w rzędzie są puste
        if (allEmpty) {
          chunk.forEach((field) => {
            field.classList.remove("error"); // Usuwamy klasę error z każdego elementu w rzędzie
          });
        }
      }
    });
  };

  const sendPreAlert = async () => {
    checkForm();
    checkTable();

    const tableFields = document.querySelectorAll(
      "#amazon-table input[required]"
    );
    for (let i = 0; i < tableFields.length; i++) {
      if (tableFields[i].value === "") {
        openToast("Please complete all fields");
        return;
      }
    }

    // Destrukturyzacja objectValue
    const {
      email,
      firstDate,
      from,
      phoneNumber,
      trailerPlates,
      trailerType,
      type,
      swapbodyPlates,
      swapbodyPlates2,
      sealNumber,
      sealNumber2,
    } = objectValue;

    // Walidacja pól
    if (
      !email ||
      !firstDate ||
      !from ||
      !phoneNumber ||
      !trailerPlates ||
      (type === "swapbody" || type === "trailer" ? !swapbodyPlates : false) ||
      !type ||
      !sealNumber
    ) {
      openToast("Please complete all fields");
      return;
    }

    const id = await alertID();

    const obj = {
      from,
      email,
      phoneNumber,
      cars: objectValue.cars,
      firstDate: new Date(firstDate), // Tworzenie daty
      type,
      trailerType: trailerType || '',
      trailerPlates,
      swapbodyPlates: swapbodyPlates || "", // Domyślna wartość na ''
      swapbodyPlates2: swapbodyPlates2 || "",
      sealNumber,
      sealNumber2: sealNumber2 || "", // Domyślna wartość na ''
      id: id,
    };

    const obj2 = {
      email,
      id: id,
      my_html: `<h3>Pre Alert no #${id}</h3><br/><br/><p>Dear User,</p><p>We would like to inform you that the pre-alert date has been set for <strong>${firstDate.replace(
        "T",
        " "
      )}</strong>. If you have any questions, please contact our customer support team.</p><p>Best regards,<br>Slam Poland</p>`,
    };

    try {
      const docRef = doc(db, "pre-alerts", "euoso0pRR5PZw2wBnjOW"); // Referencja do dokumentu
      // Wysyłanie e-maila
      await axios.post('http://localhost:8080/sendMail', obj2).then(async() => {
        await updateDoc(docRef, {
          alerts: arrayUnion(obj), // Użycie arrayUnion do dodawania obiektów
        }).then(() => window.location.reload())
      })


      // Aktualizacja Firestore z użyciem modularnego podejścia


    } catch (error) {
      console.error("Error sending pre-alert:", error);
      openToast("Failed to send pre-alert. Please try again.");
    }
  };

  const handleUpdate = (e, index) => {
    if (
      e.target.name === "receiving" ||
      e.target.name === "numberFBA" ||
      e.target.name === "quantity" ||
      e.target.name === "palletsNumber"
    ) {
      const { name, value } = e.target;
      const updatedCars = [...objectValue.cars];

      if (name === "quantity" || name === "palletsNumber") {
        updatedCars[index - 1][name] = value === "" ? 0 : value;
      } else {
        updatedCars[index - 1][name] = value;
      }
      setObjectValue({ ...objectValue, cars: updatedCars });
    } else {
      setObjectValue((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const carsHandleUpdate = (e, index) => {
    const { name, value } = e.target;
    const updatedCars = [...objectValue.cars];
    updatedCars[index][name] =
      name === "quantity" || name === "palletsNumber"
        ? value === ""
          ? 0
          : value
        : value;
    setObjectValue({ ...objectValue, cars: updatedCars });
  };

  const handleUpdatePreAlert = async (e) => {
    if (Object.keys(preAlert).length > 0) {
        const index = preAlerts.findIndex(obj => obj.id === preAlert.id);

        const alerts = Array.from(preAlerts);
        const updateObj = {
            cars: [
                {
                    id: 1,
                    receiving: (objectValue.cars[0].receiving !== '' && objectValue.cars[0].receiving !== undefined ? objectValue.cars[0].receiving : preAlerts[index].cars[0].receiving),
                    numberFBA: (objectValue.cars[0].numberFBA !== '' && objectValue.cars[0].numberFBA !== undefined ? objectValue.cars[0].numberFBA : preAlerts[index].cars[0].numberFBA),
                    quantity: (objectValue.cars[0].quantity !== 0 && objectValue.cars[0].quantity !== undefined ? objectValue.cars[0].quantity : preAlerts[index].cars[0].quantity),
                    palletsNumber: (objectValue.cars[0].palletsNumber !== 0 && objectValue.cars[0].palletsNumber !== undefined ? objectValue.cars[0].palletsNumber : preAlerts[index].cars[0].palletsNumber)
                },
                {
                    id: 2,
                    receiving: (objectValue.cars[1].receiving2 !== '' && objectValue.cars[1].receiving2 !== undefined ? objectValue.cars[1].receiving2 : preAlerts[index].cars[1].receiving),
                    numberFBA: (objectValue.cars[1].numberFBA2 !== '' && objectValue.cars[1].numberFBA2 !== undefined ? objectValue.cars[1].numberFBA2 : preAlerts[index].cars[1].numberFBA),
                    quantity: (objectValue.cars[1].quantity2 !== 0 && objectValue.cars[1].quantity2 !== undefined ? objectValue.cars[1].quantity2 : preAlerts[index].cars[1].quantity),
                    palletsNumber: (objectValue.cars[1].palletsNumber2 !== 0 && objectValue.cars[1].palletsNumber2 !== undefined ? objectValue.cars[1].palletsNumber2 : preAlerts[index].cars[1].palletsNumber)
                }
            ],
            from: (objectValue.from !== '' && objectValue.from !== undefined ? objectValue.from : preAlerts[index].from),
            email: (objectValue.email !== '' && objectValue.email !== undefined ? objectValue.email : preAlerts[index].email),
            phoneNumber: (objectValue.phoneNumber !== '' && objectValue.phoneNumber !== undefined ? objectValue.phoneNumber : preAlerts[index].phoneNumber),
            sealNumber: (objectValue.sealNumber !== '' && objectValue.sealNumber !== undefined ? objectValue.sealNumber : preAlerts[index].sealNumber),
            sealNumber2: (objectValue.sealNumber2 !== undefined ? objectValue.sealNumber2 : (preAlerts[index].sealNumber2 === undefined ? '' : preAlerts[index].sealNumber2)),
            type: (objectValue.type !== '' && objectValue.type !== undefined ? objectValue.type : preAlerts[index].type),
            trailerType: (objectValue.trailerType !== '' && objectValue.trailerType !== undefined ? objectValue.trailerType : preAlerts[index].trailerType),
            trailerPlates: (objectValue.trailerPlates !== '' && objectValue.trailerPlates !== undefined ? objectValue.trailerPlates : preAlerts[index].trailerPlates),
            swapbodyPlates: (objectValue.swapbodyPlates !== '' && objectValue.swapbodyPlates !== undefined ? objectValue.swapbodyPlates : preAlerts[index].swapbodyPlates),
            swapbodyPlates2: (objectValue.swapbodyPlates2 !== undefined ? objectValue.swapbodyPlates2 : (preAlerts[index].swapbodyPlates2 === undefined ? '' : preAlerts[index].swapbodyPlates2)),
            firstDate: (objectValue.firstDate !== '' && objectValue.firstDate !== undefined ? new Date(objectValue.firstDate) : preAlerts[index].firstDate),
            id: preAlerts[index].id
        };

        const additionalCarsCount = preAlert.cars.length - 2;
        for (let i = 0; i < additionalCarsCount; i++) {
            updateObj.cars.push({
                receiving: (objectValue.cars[i + 2].receiving !== '' && objectValue.cars[i + 2].receiving !== undefined ? objectValue.cars[i + 2].receiving : preAlerts[index].cars[i + 2].receiving),
                numberFBA: (objectValue.cars[i + 2].numberFBA !== '' && objectValue.cars[i + 2].numberFBA !== undefined ? objectValue.cars[i + 2].numberFBA : preAlerts[index].cars[i + 2].numberFBA),
                id: i + 3, // Nowy numer ID
                quantity: (objectValue.cars[i + 2].quantity !== 0 && objectValue.cars[i + 2].quantity !== undefined ? objectValue.cars[i + 2].quantity : preAlerts[index].cars[i + 2].quantity),
                palletsNumber: (objectValue.cars[i + 2].palletsNumber !== 0 && objectValue.cars[i + 2].palletsNumber !== undefined ? objectValue.cars[i + 2].palletsNumber : preAlerts[index].cars[i + 2].palletsNumber),
            });
        }

        if (objectValue.firstDate !== undefined) {
            if (new Date(objectValue.firstDate) !== new Date(preAlert.firstDate.seconds * 1000 + preAlert.firstDate.nanoseconds / 1000000)) {
                updateObj.isChanged = true;

                const colonIndex = new Date(objectValue.firstDate).toISOString().lastIndexOf(':');
                const date = moment(new Date(objectValue.firstDate).toISOString()).local().format('YYYY-MM-DD HH:mm');
                const updateDate = date;

                const obj = {
                    email: alerts[index]['email'],
                    id: alerts[index]['id'],
                    my_html: `<h3>Pre Alert no #${alerts[index]['id']}</h3><br/><br/><p>Dear User,</p><p>We would like to inform you that the date for the pre-alert has been changed. Please note the updated date for your records:</p><p><strong>New Pre-Alert Date:</strong> ${updateDate}</p><p>If you have any questions or concerns regarding this change, feel free to reach out to our customer support team.</p><p>Thank you for your understanding.</p><p>Best regards,<br>Slam Poland</p>`
                }

                await axios.post('http://localhost:8080/sendMail', obj).then(
                    () => {
                        console.log('SUCCESS!');
                    },
                    (error) => {
                        console.log('FAILED...', error.text);
                    },
                );
            }
        }

        alerts.splice(index, 1);
        alerts.push(updateObj);

        // Zaktualizuj Firestore
        const docRef = doc(db, 'pre-alerts', 'euoso0pRR5PZw2wBnjOW'); // Referencja do dokumentu
        await updateDoc(docRef, { alerts: alerts })
            .then(() => window.location.reload())
            .catch((error) => console.error(error));
    } else {
        openToast('Please select the pre-alert to be deleted');
    }
};

const handleUpdatePreAlert2 = async (e) => {
  if (Object.keys(preAlert).length > 0) {
    const index = preAlerts.findIndex((obj) => obj.id === preAlert.id);
    const alerts = Array.from(preAlerts);

    const updateObj = {
      cars: [
        {
          id: 1,
          receiving: objectValue.cars[0].receiving || preAlerts[index].cars[0].receiving,
          numberFBA: objectValue.cars[0].numberFBA || preAlerts[index].cars[0].numberFBA,
          quantity: objectValue.cars[0].quantity || preAlerts[index].cars[0].quantity,
          palletsNumber: objectValue.cars[0].palletsNumber || preAlerts[index].cars[0].palletsNumber,
        },
        {
          id: 2,
          receiving: objectValue.cars[1].receiving2 || preAlerts[index].cars[1].receiving,
          numberFBA: objectValue.cars[1].numberFBA2 || preAlerts[index].cars[1].numberFBA,
          quantity: objectValue.cars[1].quantity2 || preAlerts[index].cars[1].quantity,
          palletsNumber: objectValue.cars[1].palletsNumber2 || preAlerts[index].cars[1].palletsNumber,
        },
      ],
      from: objectValue.from || preAlerts[index].from,
      email: objectValue.email || preAlerts[index].email,
      phoneNumber: objectValue.phoneNumber || preAlerts[index].phoneNumber,
      sealNumber: objectValue.sealNumber || preAlerts[index].sealNumber,
      sealNumber2: objectValue.sealNumber2 || preAlerts[index].sealNumber2 || "",
      type: objectValue.type || preAlerts[index].type,
      trailerType: objectValue.trailerType || preAlerts[index].trailerType,
      trailerPlates: objectValue.trailerPlates || preAlerts[index].trailerPlates,
      swapbodyPlates: objectValue.swapbodyPlates || preAlerts[index].swapbodyPlates,
      swapbodyPlates2: objectValue.swapbodyPlates2 || preAlerts[index].swapbodyPlates2 || "",
      comment: objectValue.comment || preAlerts[index].comment || "",
      firstDate: objectValue.firstDate ? new Date(objectValue.firstDate) : preAlerts[index].firstDate,
      arrivalDate: objectValue.arrivalDate ? new Date(objectValue.arrivalDate) : preAlerts[index].arrivalDate,
      unloadingDate: objectValue.unloadingDate ? new Date(objectValue.unloadingDate) : preAlerts[index].unloadingDate,
      departureDate: objectValue.departureDate ? new Date(objectValue.departureDate) : preAlerts[index].departureDate,
      vehicleRegistration: objectValue.vehicleRegistration || preAlerts[index].vehicleRegistration,
      id: preAlerts[index].id,
    };

    const additionalCarsCount = preAlert.cars.length - 2;
    for (let i = 0; i < additionalCarsCount; i++) {
      updateObj.cars.push({
        id: i + 3,
        receiving: objectValue.cars[i + 2].receiving || preAlerts[index].cars[i + 2].receiving,
        numberFBA: objectValue.cars[i + 2].numberFBA || preAlerts[index].cars[i + 2].numberFBA,
        quantity: objectValue.cars[i + 2].quantity || preAlerts[index].cars[i + 2].quantity,
        palletsNumber: objectValue.cars[i + 2].palletsNumber || preAlerts[index].cars[i + 2].palletsNumber,
      });
    }

    if (objectValue.firstDate) {
      if (
        new Date(objectValue.firstDate) !==
        new Date(preAlert.firstDate.seconds * 1000 + preAlert.firstDate.nanoseconds / 1000000)
      ) {
        const date = new Date(objectValue.firstDate);
        date.setHours(date.getHours() + 1);
        const updateDate = date.toISOString().replace("T", " ").split(":").slice(0, -1).join(":");

        const emailObj = {
          email: alerts[index]["email"],
          id: alerts[index]['id'],
          my_html: `<h3>Pre Alert no #${alerts[index]["id"]}</h3><br/><br/><p>Dear User,</p><p>We would like to inform you that the date for the pre-alert has been changed. Please note the updated date for your records:</p><p><strong>New Pre-Alert Date:</strong> ${updateDate}</p><p>If you have any questions or concerns regarding this change, feel free to reach out to our customer support team.</p><p>Thank you for your understanding.</p><p>Best regards,<br>Slam Poland</p>`,
        };

        await axios.post('http://localhost:8080/sendMail', emailObj).then(
          () => console.log("SUCCESS!"),
          (error) => console.log("FAILED...", error.text)
        );
      }
    }

    alerts.splice(index, 1);
    alerts.push(updateObj);

    // Zaktualizuj Firestore
    const docRef = doc(db, 'pre-alerts', 'euoso0pRR5PZw2wBnjOW'); // Referencja do dokumentu
    await updateDoc(docRef, { alerts: alerts })
      .then(() => window.location.reload())
      .catch((error) => console.error(error));
  } else {
    openToast("Please select the pre-alert to be deleted");
  }
};

// async function deleteRecord() {
//   const index = preAlerts.findIndex(obj => obj.id === preAlert.id);
  
//   if (index === -1) {
//     console.error("Pre-alert not found");
//     return; // Zakończ funkcję, jeśli nie znaleziono pre-alert
//   }

//   const alerts = Array.from(preAlerts);
//   alerts.splice(index, 1); // Usunięcie pre-alert

//   try {
//     const docRef = doc(db, 'pre-alerts', 'euoso0pRR5PZw2wBnjOW'); // Tworzenie referencji do dokumentu
//     await updateDoc(docRef, { alerts: alerts }); // Aktualizacja dokumentu
//     window.location.reload(); // Odświeżenie strony
//   } catch (error) {
//     console.error("Error updating document:", error); // Obsługa błędu
//   }
// }

  const openToast = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.error(message, {
        position: "top-center",
      });
    }
  };

  const openToast2 = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.success(message, {
        position: "top-center",
      });
    }
  };


  const handleCancel = async (e) => {
    if(isCanceled){
      return;
    }
    if (!objectValue.nameAndSurname) {
      openToast("Please enter your first and last name");
      return;
    }
  
    if (Object.keys(preAlert).length > 0) {
      setIsCanceled(true);
      const index = preAlerts.findIndex((obj) => obj.id === preAlert.id);
      const alerts = JSON.parse(JSON.stringify(preAlerts));
      const date = moment(new Date(alerts[index].firstDate.seconds * 1000 + alerts[index].firstDate.nanoseconds / 1000000).toISOString()).local().format('YYYY-MM-DD HH:mm');
      
      alerts[index]["isCancel"] = true;
      const obj = {
        email: alerts[index]["email"],
        id: alerts[index]["id"],
        my_html: `<h3>Pre Alert no #${alerts[index]["id"]}</h3><br/><br/><p>Dear User,</p><p>We want to inform you that the pre-alert with date <strong>${date}</strong> has been canceled. All necessary steps have been taken to ensure continuity of operations according to our plans.</p><p>Thank you for your patience and cooperation throughout this process. Please feel free to contact our customer support department if you have any questions or concerns.</p><p>Best regards,</p><p>Slam Poland</p>`,
      };
  
      try {
        const docRef = doc(db, 'pre-alerts', 'euoso0pRR5PZw2wBnjOW'); // Tworzenie referencji do dokumentu

        await axios.post('http://localhost:8080/sendMail', obj).then(async() => {
          // Zaktualizowanie Firestore z użyciem modularnego API
          await updateDoc(docRef, { alerts: alerts }).then(() => {
            console.log("SUCCESS!");
            //await rejectionEmail(); // Wywołanie funkcji rejectionEmail po aktualizacji
            openToast2('Pre-alert has been successfully canceled.'); // Powiadomienie o błędzie
            setTimeout(window.location.reload(), 1000);
          });
        });
      } catch (error) {
        console.error("Error sending email or updating document:", error);
        setIsCanceled(false);
        openToast2('Pre-alert has not been successfully canceled.'); // Powiadomienie o błędzie
      }
    } else {
      openToast("Please select the pre-alert to be canceled");
      setIsCanceled(false);
    }
  };

  const search = document.querySelector("#search");

  if (search)
    search.addEventListener("keyup", (e) => {
      // Sprawdź, czy naciśnięty klawisz to "Enter" (keyCode 13)
      if (e.keyCode === 13) {
        // Tutaj umieść kod, który ma zostać wykonany po naciśnięciu klawisza "Enter"
        filteredAlerts();
      }
    });

  function checkForm() {
    const inputs = document.querySelectorAll("input[required]");
    const select = document.querySelector("select[required]");
    const textarea = document.querySelector("textarea[required]");

    if (textarea) {
      if (textarea.value.trim() === "") {
        textarea.classList.add("error");
      } else {
        textarea.classList.remove("error");
      }
    }

    if (select.value.trim() === "") {
      select.classList.add("error");
    } else {
      select.classList.remove("error");
    }

    inputs.forEach(function (input) {
      if (input.value.trim() === "") {
        input.classList.add("error");
      } else {
        input.classList.remove("error");
      }
    });

    if (input.name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const validate = emailRegex.test(input.value);
      console.log(validate);
      if (validate) {
        input.classList.remove("error");
        setEmailValidate(validate);
      } else {
        input.classList.add("error");
        setEmailValidate(validate);
      }
    }
  }

  function checkIndividualForm(e) {
    if (e.target.value !== "") {
      e.target.classList.remove("error");
    }
  }

  function checkIndividualEmailValidate(e) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validate = emailRegex.test(e.target.value);
    if (validate) {
      e.target.classList.remove("error");
      setEmailValidate(validate);
    } else {
      e.target.classList.add("error");
      setEmailValidate(validate);
    }
  }

  useEffect(() => {
    if (objectValue.cars && objectValue.cars.length > 0) {
      const totalQuantity = objectValue.cars.reduce(
        (accumulator, car) => parseInt(accumulator) + parseInt(car.quantity),
        0
      );
      setUnitsTotal(totalQuantity);
      const totalPallets = (
        objectValue.cars ? objectValue.cars : preAlert.cars
      ).reduce(
        (accumulator, car) =>
          parseInt(accumulator) + parseInt(car.palletsNumber),
        0
      );
      setPalletsTotal(totalPallets);
    }
  }, [objectValue, preAlert]);

  const openModal = () => {
    if (Object.keys(preAlert).length > 0) {
      setOpen(!open);
    } else {
      openToast("Please select pre-alert");
    }
  };

  const rejectionEmail = () => {
    checkForm();
    if (
      objectValue.nameAndSurname !== undefined &&
      objectValue.nameAndSurname !== ""
    ) {
      const index = preAlerts.findIndex((obj) => obj === preAlert);
      const colonIndex = new Date(
        preAlert.firstDate.seconds * 1000 +
          preAlert.firstDate.nanoseconds / 1000000 +
          3600000
      )
        .toISOString()
        .lastIndexOf(":");
      const colonIndex4 = new Date(
        preAlert.arrivalDate.seconds * 1000 +
          preAlert.arrivalDate.nanoseconds / 1000000 +
          3600000
      )
        .toISOString()
        .lastIndexOf(":");
      const colonIndex2 = new Date(
        preAlert.unloadingDate.seconds * 1000 +
          preAlert.unloadingDate.nanoseconds / 1000000 +
          3600000
      )
        .toISOString()
        .lastIndexOf(":");
      const colonIndex3 = new Date(
        preAlert.arrivalDate.seconds * 1000 +
          preAlert.arrivalDate.nanoseconds / 1000000 +
          3600000
      )
        .toISOString()
        .lastIndexOf(":");

      const carsDataString = objectValue.cars
        .map(
          (car, carIndex) =>
            `${
              car.receiving !== "" && car.receiving !== undefined
                ? car.receiving
                : preAlerts[index].cars[carIndex].receiving
            } ${
              car.numberFBA !== "" && car.numberFBA !== undefined
                ? car.numberFBA
                : preAlerts[index].cars[carIndex].numberFBA
            } ${
              car.quantity !== 0 && car.quantity !== undefined
                ? car.quantity
                : preAlerts[index].cars[carIndex].quantity
            } ${
              car.palletsNumber !== 0 && car.palletsNumber !== undefined
                ? car.palletsNumber
                : preAlerts[index].cars[carIndex].palletsNumber
            }`
        )
        .join("\n");

      const message =
        "Hello,\n\n" +
        `Pre-Alert no #${preAlerts[index].id}\n` +
        `From: ${
          objectValue.from !== "" && objectValue.from !== undefined
            ? objectValue.from
            : preAlerts[index].from
        }\n` +
        `Email: ${
          objectValue.email !== "" && objectValue.email !== undefined
            ? objectValue.email
            : preAlerts[index].email
        }\n` +
        `Phone number: ${
          objectValue.phoneNumber !== "" &&
          objectValue.phoneNumber !== undefined
            ? objectValue.phoneNumber
            : preAlerts[index].phoneNumber
        }\n` +
        `Type of vehicle: ${
          objectValue.type !== "" && objectValue.type !== undefined
            ? objectValue.type
            : preAlerts[index].type
        }\n` +
        `Truck plates: ${
          objectValue.trailerPlates !== "" &&
          objectValue.trailerPlates !== undefined
            ? objectValue.trailerPlates
            : preAlerts[index].trailerPlates
        }\n` +
        `Trailer type: ${
          objectValue.trailerType !== "" &&
          objectValue.trailerType !== undefined
            ? objectValue.trailerType
            : preAlerts[index].trailerType
        }\n` +
        `Trailer plate/swapbody #1: ${
          objectValue.swapbodyPlates !== "" &&
          objectValue.swapbodyPlates !== undefined
            ? objectValue.swapbodyPlates
            : preAlerts[index].swapbodyPlates
        }\n` +
        `Swabody #2: ${
          objectValue.swapbodyPlates2 !== undefined
            ? objectValue.swapbodyPlates2
            : preAlerts[index].swapbodyPlates2 === undefined
            ? ""
            : preAlerts[index].swapbodyPlates2
        }\n` +
        `Delivery date: ${
          objectValue.firstDate !== "" && objectValue.firstDate !== undefined
            ? new Date(objectValue.firstDate)
            : moment(
                new Date(
                  preAlert.firstDate.seconds * 1000 +
                    preAlert.firstDate.nanoseconds / 1000000
                ).toISOString()
              )
                .local()
                .format("YYYY-MM-DD HH:mm:ss")
        }\n` +
        `Seal number #1: ${
          objectValue.sealNumber !== "" && objectValue.sealNumber !== undefined
            ? objectValue.sealNumber
            : preAlerts[index].sealNumber
        }\n` +
        `Seal number #2: ${
          objectValue.sealNumber2 !== undefined
            ? objectValue.sealNumber2
            : preAlerts[index].sealNumber2 === undefined
            ? ""
            : preAlerts[index].sealNumber2
        }\n` +
        `Receiving   FBA Number   Quantity   Pallets Number\n` +
        `${carsDataString}\n` +
        +"\n\n" +
        `Name and surname: ${objectValue.nameAndSurname}\n` +
        `Arrival date: ${new Date(
          preAlert.arrivalDate.seconds * 1000 +
            preAlert.arrivalDate.nanoseconds / 1000000 +
            3600000
        )
          .toISOString()
          .replace("T", " ")
          .slice(0, colonIndex4)}\n` +
        `Start of unloading: ${new Date(
          preAlert.unloadingDate.seconds * 1000 +
            preAlert.unloadingDate.nanoseconds / 1000000 +
            3600000
        )
          .toISOString()
          .replace("T", " ")
          .slice(0, colonIndex2)}\n` +
        `Cancelation of unloading: ${new Date(
          preAlert.unloadingDate.seconds * 1000 +
            preAlert.unloadingDate.nanoseconds / 1000000 +
            3600000
        )
          .toISOString()
          .replace("T", " ")
          .slice(0, colonIndex2)}\n` +
        `Departure date: ${new Date(
          preAlert.departureDate.seconds * 1000 +
            preAlert.departureDate.nanoseconds / 1000000 +
            3600000
        )
          .toISOString()
          .replace("T", " ")
          .slice(0, colonIndex3)}\n` +
        `Comment: ${objectValue.comment}\n` +
        +"\n\n" +
        "Best regards,\nSlam Poland";
      // Koduj treść wiadomości dla mailto
      const encodedMessage = encodeURIComponent(message);
      const mailtoLink =
        "mailto:adres@adres.com?subject=Odrzucenie%20zapytania&body=" +
        encodedMessage;
      window.location.href = mailtoLink;
      window.location.reload();
    } else {
      openToast("Please enter your first and last name");
    }
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(!open);

  const addCar = () => {
    setObjectValue((prevState) => {
      const newCar = {
        id: prevState.cars.length + 1,
        receiving: "",
        numberFBA: "",
        quantity: 0,
        palletsNumber: 0,
      };
      return {
        ...prevState,
        cars: [...prevState.cars, newCar],
      };
    });
  };

  const limitedFields = Math.min(fields, 38);

  useEffect(() => {
    const preAlertBox = document.querySelector('.pre-alert-box');
    
    if(preAlertBox) 
      setPreAlertHeight(preAlertBox.offsetHeight)
  }, [preAlert])

  return (
    <>
      <ToastContainer
        style={{ width: "800px", zIndex: 10000 }}
        autoClose={2000}
      />
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />

      <div
        className="content"
        style={{ display: "flex", flexFlow: "row nowrap" }}
      >
        <Card
          className="bg-my-black"
          style={{ borderRadius: "8px", width: "20%", height: preAlertHeight }}
        >
          <List style={{ marginTop: "10px" }}>
            <InputGroup className="no-border">
              <Input
                onChange={(e) => {
                  e.preventDefault();
                  setWantedAlert(e.target.value);
                }}
                id="search"
                placeholder="Search pre-alerts"
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  onClick={() => filteredAlerts()}
                  style={{ backgroundColor: "white", cursor: "pointer" }}
                >
                  <i
                    style={{ color: "rgb(255, 193, 7)" }}
                    className="nc-icon nc-zoom-split"
                  />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
            {filteredPreAlerts
              ? filteredPreAlerts.map((alert, index) => {
                  const realyIndex = preAlerts.findIndex(
                    (obj) => obj === alert
                  );
                  const deliveryDate = new Date(
                    alert.firstDate.seconds * 1000 +
                      alert.firstDate.nanoseconds / 1000000
                  );
                  const today = new Date();

                  return (
                    <ListItem
                      style={
                        preAlert.id === alert.id
                          ? { color: "#ffc107" }
                          : alert.isCancel && alert.isCancel === true
                          ? { color: "#CC0C39" }
                          : alert.isRealized && alert.isRealized === true
                          ? { color: "#008000" }
                          : deliveryDate < today
                          ? { color: "#0080ff" }
                          : alert.isLeaving && alert.isLeaving === true
                          ? { color: "#964b00" }
                          : alert.isChanged && alert.isChanged === true
                          ? { color: "#ff8413" }
                          : { color: "#ffffff" }
                      }
                      onClick={() => {
                        dispatch(updateTitle(`Pre-Alert no #${alert.id}`));
                        dispatch(updatePreAlert(preAlerts[realyIndex]));
                        setObjectValue({
                          cars: [
                            {
                              type: "",
                              id: 1,
                              quantity: "",
                              palletsNumber: "",
                              numberFBA: "",
                              receiving: "",
                            },
                            {
                              receiving2: "",
                              type2: "",
                              id: 2,
                              quantity2: "",
                              palletsNumber2: "",
                              numberFBA2: "",
                            },
                          ],
                        });
                        setTimeout(checkForm, 100);
                      }}
                      className="py-1 pr-1 pl-4 list"
                    >
                      Pre-Alert no #{alert.id}
                    </ListItem>
                  );
                })
              : preAlerts
              ? preAlerts.map((alert, index) => {
                  const deliveryDate = new Date(
                    alert.firstDate.seconds * 1000 +
                      alert.firstDate.nanoseconds / 1000000
                  );
                  const today = new Date();

                  return (
                    <ListItem
                      style={
                        preAlert.id === alert.id
                          ? { color: "#ffc107" }
                          : alert.isCancel && alert.isCancel === true
                          ? { color: "#CC0C39" }
                          : alert.isRealized && alert.isRealized === true
                          ? { color: "#008000" }
                          : deliveryDate < today
                          ? { color: "#0080ff" }
                          : alert.isChanged && alert.isChanged === true
                          ? { color: "#ff8413" }
                          : alert.isLeaving && alert.isLeaving === true
                          ? { color: "#964b00" }
                          : alert.isChanged && alert.isChanged === true
                          ? { color: "#ff8413" }
                          : { color: "#ffffff" }
                      }
                      onClick={() => {
                        dispatch(updateTitle(`Pre-Alert no #${alert.id}`));
                        dispatch(updatePreAlert(preAlerts[index]));
                        setObjectValue({
                          cars: [
                            {
                              type: "",
                              id: 1,
                              quantity: "",
                              palletsNumber: "",
                              numberFBA: "",
                              receiving: "",
                            },
                            {
                              receiving2: "",
                              type2: "",
                              id: 2,
                              quantity2: "",
                              palletsNumber2: "",
                              numberFBA2: "",
                            },
                          ],
                        });
                        setTimeout(checkForm, 100);
                      }}
                      className="py-1 pr-1 pl-4 list"
                    >
                      Pre-Alert no #{alert.id}
                    </ListItem>
                  );
                })
              : ""}
          </List>
        </Card>
        <Card
          style={{
            borderRadius: "8px",
            padding: "20px",
            width: "80%",
            marginLeft: "0.5rem",
          }}
          className="pre-alert-box"
        >
          <Dialog open={open} size={"xxl"} handler={handleOpen}>
            <DialogBody
              style={{ width: "100vw", height: "100vh", overflowX: "hidden" }}
            >
              <div
                style={{
                  display: "flex",
                  flexFlow: "row nowrap",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                  height: "50px",
                }}
              >
                <IoClose
                  onClick={() => handleOpen()}
                  style={{
                    width: "35px",
                    height: "35px",
                    color: "#FFD814",
                    cursor: "pointer",
                  }}
                />
              </div>
              <div className="container text-left">
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Name and surname
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="nameAndSurname"
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    <strong>Comment:</strong>
                  </label>
                  <textarea
                    className="form-control"
                    style={{ paddingLeft: "12px", paddingTop: "2px" }}
                    id="formGroupExampleInput"
                    placeholder=""
                    name="comment"
                    value={
                      objectValue.comment === undefined
                        ? preAlert.comment
                        : objectValue.comment
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <Button
                  style={{ textTransform: "none" }}
                  onClick={() => handleCancel()}
                >
                  Cancel Pre-Alert
                </Button>
              </div>
            </DialogBody>
          </Dialog>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h3>{title}</h3>
            <Button
              style={{ textTransform: "none" }}
              onClick={() => {
                dispatch(updateTitle(`Add new pre-alert`));
                dispatch(updatePreAlert({}));
              }}
            >
              Add new pre-alert
            </Button>
          </div>
          <div className="container text-left">
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                From
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder="Company Name"
                name="from"
                value={
                  objectValue.from !== undefined
                    ? objectValue.from
                    : Object.keys(preAlert).length > 0
                    ? preAlert.from
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput2" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="formGroupExampleInput2"
                placeholder="e.g. office@slampoland.pl"
                name="email"
                value={
                  objectValue.email !== undefined
                    ? objectValue.email
                    : Object.keys(preAlert).length > 0
                    ? preAlert.email
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualEmailValidate(e);
                }}
                required
              />
              {!emailValidate ? (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#CC0C39",
                    marginLeft: "2px",
                    marginTop: "5px",
                  }}
                >
                  Provide a valid email address
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Phone number
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder="+48 777 777 777"
                name="phoneNumber"
                value={
                  objectValue.phoneNumber !== undefined
                    ? objectValue.phoneNumber
                    : Object.keys(preAlert).length > 0
                    ? preAlert.phoneNumber
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Type of vehicle
              </label>
              <select
                className="form-control"
                id="type2"
                value={
                  objectValue.type !== undefined || objectValue.type === ""
                    ? objectValue.type
                    : Object.keys(preAlert).length > 0
                    ? preAlert.type
                    : ""
                }
                name="type"
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                type="text"
                required
              >
                <option></option>
                <option>trailer</option>
                <option>swapbody</option>
                <option>bus, van</option>
                <option>loose</option>
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Truck plates
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder=""
                name="trailerPlates"
                value={
                  objectValue.trailerPlates !== undefined
                    ? objectValue.trailerPlates
                    : Object.keys(preAlert).length > 0
                    ? preAlert.trailerPlates
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            {objectValue.type === "loose" || preAlert.type === "loose" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput2" className="form-label">
                  Trailer type
                </label>
                <select
                  className="form-control"
                  id="type2"
                  name="trailerType"
                  value={
                    objectValue.trailerType !== undefined ||
                    objectValue.trailerType === ""
                      ? objectValue.trailerType
                      : Object.keys(preAlert).length > 0
                      ? preAlert.trailerType
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                  type="text"
                  required
                >
                  <option selected disabled></option>
                  <option>live</option>
                  <option>drop</option>
                </select>
              </div>
            ) : (
              ""
            )}
            {objectValue.type === "swapbody" ||
            objectValue.type === "trailer" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">
                  Trailer plate/swapbody #1
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="formGroupExampleInput"
                  placeholder=""
                  name="swapbodyPlates"
                  value={
                    objectValue.swapbodyPlates !== undefined
                      ? objectValue.swapbodyPlates
                      : Object.keys(preAlert).length > 0
                      ? preAlert.swapbodyPlates
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                  required
                />
              </div>
            ) : (
              ""
            )}
            {objectValue.type === "swapbody" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">
                  Swapbody #2
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="formGroupExampleInput"
                  placeholder=""
                  name="swapbodyPlates2"
                  value={
                    objectValue.swapbodyPlates2 !== undefined
                      ? objectValue.swapbodyPlates2
                      : Object.keys(preAlert).length > 0
                      ? preAlert.swapbodyPlates2
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                />
              </div>
            ) : (
              ""
            )}
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                <strong>Delivery date:</strong>
              </label>
              <input
                type="datetime-local"
                className="form-control"
                id="formGroupExampleInput"
                placeholder=""
                name="firstDate"
                value={
                  objectValue.firstDate
                    ? objectValue.firstDate
                    : Object.keys(preAlert).length > 0
                    ? moment(
                        new Date(
                          preAlert.firstDate.seconds * 1000 +
                            preAlert.firstDate.nanoseconds / 1000000
                        ).toISOString()
                      )
                        .local()
                        .format("YYYY-MM-DD HH:mm:ss")
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            <div className="row">
              <div className="col">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Receiving AMAZON-FC</th>
                      <th scope="col">FBA-Number</th>
                      <th scope="col">Quantity of units</th>
                      <th scope="col">No of pallets</th>
                    </tr>
                  </thead>
                  <tbody id="amazon-table">
                    <tr>
                      <th scope="row">
                        <input
                          className="form-control"
                          name="receiving"
                          value={
                            objectValue.cars[0].receiving !== ""
                              ? objectValue.cars[0].receiving
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[0].receiving
                              : ""
                          }
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          id="receive"
                          type="text"
                          required
                        />
                      </th>
                      <td>
                        <input
                          className="form-control"
                          id="fba-number"
                          value={
                            objectValue.cars[0].numberFBA !== ""
                              ? objectValue.cars[0].numberFBA
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[0].numberFBA
                              : ""
                          }
                          name="numberFBA"
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          type="text"
                          required
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="quantity-of-units"
                          value={
                            objectValue.cars[0].quantity !== ""
                              ? objectValue.cars[0].quantity
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[0].quantity
                              : ""
                          }
                          name="quantity"
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          type="number"
                          required
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="no-of-pallets"
                          name="palletsNumber"
                          value={
                            objectValue.cars[0].palletsNumber !== "" &&
                            objectValue.cars[0].palletsNumber !== 0
                              ? objectValue.cars[0].palletsNumber
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[0].palletsNumber
                              : ""
                          }
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          type="number"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <input
                          className="form-control"
                          name="receiving"
                          value={
                            objectValue.cars[1].receiving !== ""
                              ? objectValue.cars[1].receiving
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[1].receiving
                              : ""
                          }
                          onChange={(e) => handleUpdate(e, 2)}
                          id="receive2"
                          type="text"
                          required={
                            objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0
                              ? true
                              : false
                          }
                        />
                      </th>
                      <td>
                        <input
                          className="form-control"
                          id="fba-number2"
                          name="numberFBA"
                          value={
                            objectValue.cars[1].numberFBA !== ""
                              ? objectValue.cars[1].numberFBA
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[1].numberFBA
                              : ""
                          }
                          onChange={(e) => handleUpdate(e, 2)}
                          type="text"
                          required={
                            objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0
                              ? true
                              : false
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="quantity-of-units2"
                          name="quantity"
                          value={
                            objectValue.cars[1].quantity !== "" &&
                            objectValue.cars[1].quantity !== 0
                              ? objectValue.cars[1].quantity
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[1].quantity
                              : ""
                          }
                          onChange={(e) => {
                            handleUpdate(e, 2);
                          }}
                          type="number"
                          required={
                            objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0
                              ? true
                              : false
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="no-of-pallets2"
                          name="palletsNumber"
                          value={
                            objectValue.cars[1].palletsNumber !== "" &&
                            objectValue.cars[1].palletsNumber !== 0
                              ? objectValue.cars[1].palletsNumber
                              : Object.keys(preAlert).length > 0
                              ? preAlert.cars[1].palletsNumber
                              : ""
                          }
                          onChange={(e) => handleUpdate(e, 2)}
                          type="number"
                          required={
                            objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0
                              ? true
                              : false
                          }
                        />
                      </td>
                    </tr>
                    {title === "Add new pre-alert" ? (
                      <>
                        {Array.from({ length: limitedFields }).map(
                          (_, index) => (
                            <tr>
                              <th scope="row">
                                <input
                                  className="form-control"
                                  name="receiving"
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  id="receive2"
                                  type="text"
                                />
                              </th>
                              <td>
                                <input
                                  className="form-control"
                                  id="fba-number2"
                                  name="numberFBA"
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="quantity-of-units2"
                                  name="quantity"
                                  onChange={(e) => {
                                    carsHandleUpdate(e, index + 2);
                                  }}
                                  type="number"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="no-of-pallets2"
                                  name="palletsNumber"
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="number"
                                />
                              </td>
                            </tr>
                          )
                        )}
                        <tr>
                          <td style={{ padding: "5px" }}></td>
                          <td style={{ padding: "5px" }}></td>
                          <td style={{ padding: "5px" }}></td>
                          <td
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              padding: "5px",
                            }}
                          >
                            <FaPlus
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                height: "20px",
                                color: "#ffc107",
                              }}
                              onClick={() => {
                                setFields(fields + 1);
                                addCar();
                              }}
                            />
                          </td>
                        </tr>
                      </>
                    ) : (
                      Array.from({ length: preAlert.cars.length - 2 }).map(
                        (_, index) => {
                          const carIndex = objectValue.cars.findIndex(
                            (car) => car.id === index + 3
                          );
                          const preAlertCarIndex = preAlert.cars.findIndex(
                            (car) => car.id === index + 3
                          );

                          return (
                            <tr>
                              <th scope="row">
                                <input
                                  className="form-control"
                                  name="receiving"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].receiving !== ""
                                      ? objectValue.cars[carIndex][
                                          `receiving${index + 3}`
                                        ]
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex]
                                          .receiving
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  id={`receiving${index + 3}`}
                                  type="text"
                                />
                              </th>
                              <td>
                                <input
                                  className="form-control"
                                  id="fba-number2"
                                  name="numberFBA"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].numberFBA !== ""
                                      ? objectValue.cars[carIndex].numberFBA
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex]
                                          .numberFBA
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="quantity-of-units2"
                                  name="quantity"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].quantity !== 0
                                      ? objectValue.cars[carIndex].quantity
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex].quantity
                                      : ""
                                  }
                                  onChange={(e) => {
                                    carsHandleUpdate(e, index + 2);
                                  }}
                                  type="number"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="no-of-pallets2"
                                  name="palletsNumber"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].palletsNumber !==
                                      0
                                      ? objectValue.cars[carIndex].palletsNumber
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex]
                                          .palletsNumber
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="number"
                                />
                              </td>
                            </tr>
                          );
                        }
                      )
                    )}
                    <tr>
                      <th scope="row">Total</th>
                      <td></td>
                      <td className="total-td">{unitsTotal}</td>
                      <td className="total-td">{palletsTotal}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Seal number #1
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder=""
                name="sealNumber"
                value={
                  objectValue.sealNumber !== undefined
                    ? objectValue.sealNumber
                    : Object.keys(preAlert).length > 0
                    ? preAlert.sealNumber
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            {objectValue.type === "swapbody" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">
                  Seal number #2
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="formGroupExampleInput"
                  placeholder=""
                  name="sealNumber2"
                  value={
                    objectValue.sealNumber2 !== undefined
                      ? objectValue.sealNumber2
                      : Object.keys(preAlert).length > 0
                      ? preAlert.sealNumber2
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                />
              </div>
            ) : (
              ""
            )}
            {preAlert &&
            preAlert.type === "swapbody" &&
            preAlert.arrivalDate &&
            preAlert.unloadingDate &&
            preAlert.completionUnloading &&
            preAlert.departureDate &&
            preAlert.vehicleRegistration ? (
              <>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Arrival date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="arrivalDate"
                    value={
                      objectValue.arrivalDate
                        ? objectValue.arrivalDate
                        : moment(
                            new Date(
                              preAlert.arrivalDate.seconds * 1000 +
                                preAlert.arrivalDate.nanoseconds / 1000000
                            ).toISOString()
                          )
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Start of unloading
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="unloadingDate"
                    value={
                      objectValue.unloadingDate
                        ? objectValue.unloadingDate
                        : moment(
                            new Date(
                              preAlert.unloadingDate.seconds * 1000 +
                                preAlert.unloadingDate.nanoseconds / 1000000
                            ).toISOString()
                          )
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Cancelation of unloading
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="unloadingDate"
                    value={
                      objectValue.unloadincagDate
                        ? objectValue.unloadingDate
                        : moment(
                            new Date(
                              preAlert.unloadingDate.seconds * 1000 +
                                preAlert.unloadingDate.nanoseconds / 1000000
                            ).toISOString()
                          )
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Departure date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="departureDate"
                    value={
                      objectValue.departureDate
                        ? objectValue.departureDate
                        : moment(
                            new Date(
                              preAlert.departureDate.seconds * 1000 +
                                preAlert.departureDate.nanoseconds / 1000000
                            ).toISOString()
                          )
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Vehicle registration
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="vehicleRegistration"
                    value={
                      objectValue.vehicleRegistration
                        ? objectValue.vehicleRegistration
                        : preAlert.vehicleRegistration
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Comments
                  </label>
                  <textarea
                    style={{ paddingLeft: "10px", paddingTop: "0px" }}
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="comment"
                    value={
                      objectValue.comment
                        ? objectValue.comment
                        : preAlert.comment
                        ? preAlert.comment
                        : ""
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
              </>
            ) : (
              ""
            )}
            {preAlert &&
            preAlert.type === "trailer" &&
            preAlert.arrivalDate &&
            preAlert.departureDate &&
            preAlert.vehicleRegistration ? (
              <>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Arrival date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="arrivalDate"
                    value={
                      objectValue.arrivalDate
                        ? objectValue.arrivalDate
                        : moment(
                            new Date(
                              preAlert.arrivalDate.seconds * 1000 +
                                preAlert.arrivalDate.nanoseconds / 1000000
                            ).toISOString()
                          )
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Departure date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="departureDate"
                    value={
                      objectValue.departureDate
                        ? objectValue.departureDate
                        : moment(
                            new Date(
                              preAlert.departureDate.seconds * 1000 +
                                preAlert.departureDate.nanoseconds / 1000000
                            ).toISOString()
                          )
                            .local()
                            .format("YYYY-MM-DD HH:mm:ss")
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
              </>
            ) : (
              ""
            )}
            <div
              style={{
                width: "100%",
                height: "58px",
                display: "flex",
                flexFlow: "row nowrap",
                justifyContent: "space-between",
              }}
            >
              <Button
                onClick={openModal}
                // style={
                //   preAlert &&
                //   preAlert.arrivalDate &&
                //   preAlert.unloadingDate &&
                //   preAlert.completionUnloading &&
                //   preAlert.departureDate &&
                //   preAlert.vehicleRegistration
                //     ? { visibility: "visible" }
                //     : { visibility: "hidden" }
                // }
                className="btn btn-error"
              >
                Cancel
              </Button>
              <Button
                onClick={
                  title === "Add new pre-alert"
                    ? sendPreAlert
                    : preAlert.arrivalDate &&
                      preAlert.unloadingDate &&
                      preAlert.departureDate &&
                      preAlert.vehicleRegistration
                    ? handleUpdatePreAlert2
                    : handleUpdatePreAlert
                }
                id="uppercase"
                className="btn btn-warning"
              >
                {title === "Add new pre-alert" ? "Add" : "Update"}
              </Button>
              {/* <Button onClick={deleteRecord}>Delete</Button> */}
            </div>
          </div>
          <div>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-1"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                canceled
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-2"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                realized
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-3"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                after date
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-4"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                on OUT parking
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-5"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                date changed
              </p>
            </span>
          </div>
        </Card>
      </div>
    </>
  );
}

export default PreAlertManagment;
